/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "PrebookToActualBoxesService";
const log: any = LoggerModule.getInstance();

export class PrebookToActualBoxesService {
  private static instance: PrebookToActualBoxesService;
  private criteria: any;

  private constructor(props: any = {}) {}
  public static getInstance(props: any = {}): PrebookToActualBoxesService {
    if (!PrebookToActualBoxesService.instance) {
      PrebookToActualBoxesService.instance = new PrebookToActualBoxesService(
        props
      );
    }
    return PrebookToActualBoxesService.instance;
  }
  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }
  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getCommittee(args?: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    if (args) {
      this.setCriteria(args);
    }
    compProps = await agent?.getCommittee(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async deleteBox(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.deleteBox(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async sendRemainder(args: any) {
    console.log(args);
    let content: any = {};
    const agent = getAgent();
    let compProps: any = null;
    compProps = await agent?.sendRemainder(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
